module.exports = __webpack_public_path__ + "static/img/衣创空间小程序.28f8497c.jpg";